import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.ip.management.consultations');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

type StoredAnswerFile = {
    name: string;
    url: string;
};

type StoredAnswerView = {
    title: string;
    body: string;
    files: StoredAnswerFile[];
};

type MemberDetailTab = 'overview' | 'response';

@Component({
    selector: 'wiz-page-ip-management-consultations',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.ip.management.consultations/view.scss */
:host {
  display: block;
  height: 100%;
}

.saved-answer-copy {
  overflow-wrap: anywhere;
}

.ipm-member-modal-backdrop {
  position: fixed;
  z-index: 90;
  inset: 0;
  width: 100%;
  height: 100%;
  padding: 0;
  border: 0;
  background: rgba(9, 30, 20, 0.56);
  cursor: default;
}

.ipm-member-modal-backdrop:disabled {
  cursor: wait;
}

.ipm-member-modal {
  position: fixed;
  z-index: 100;
  top: 50%;
  left: 50%;
  display: flex;
  width: min(72rem, 100vw - 2rem);
  height: min(52rem, 100vh - 2rem);
  height: min(52rem, 100dvh - 2rem);
  min-height: 0;
  flex-direction: column;
  overflow: hidden;
  transform: translate(-50%, -50%);
  border: 1px solid #dce7e0;
  border-radius: 1rem;
  color: #10241a;
  background: #fff;
  box-shadow: 0 30px 90px rgba(7, 29, 18, 0.28);
  animation: ipm-member-modal-enter 180ms ease-out both;
  overscroll-behavior: contain;
}

.ipm-member-modal-header {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 1rem;
  padding: 1rem 1.1rem;
  border-bottom: 1px solid #dce7e0;
  background: #fff;
}

.ipm-member-modal-tabs {
  display: flex;
  flex: 0 0 auto;
  gap: 0.25rem;
  overflow-x: auto;
  padding: 0 1rem;
  border-bottom: 1px solid #dce7e0;
  background: #fff;
}

.ipm-member-modal-tab {
  display: inline-flex;
  height: 2.75rem;
  flex: 0 0 auto;
  align-items: center;
  gap: 0.4rem;
  padding: 0 0.85rem;
  border: 0;
  border-bottom: 2px solid transparent;
  color: #728178;
  background: transparent;
  font-size: 0.74rem;
  font-weight: 700;
  white-space: nowrap;
  transition: border-color 150ms ease, color 150ms ease, background-color 150ms ease;
}

.ipm-member-modal-tab:hover {
  color: #197443;
  background: #f7faf8;
}

.ipm-member-modal-tab:focus-visible {
  border-radius: 0.35rem 0.35rem 0 0;
  outline: 2px solid #34d399;
  outline-offset: -2px;
}

.ipm-member-modal-tab--active {
  border-bottom-color: #047857;
  color: #065f46;
}

.ipm-member-modal-tab-badge {
  padding: 0.15rem 0.4rem;
  border-radius: 999px;
  color: #047857;
  background: #ecfdf5;
  font-size: 0.58rem;
  font-weight: 800;
}

.ipm-member-modal-body {
  min-height: 0;
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 1rem;
  background: #f7faf8;
  scrollbar-color: #bfd0c5 transparent;
  scrollbar-width: thin;
}

.ipm-member-card,
.ipm-member-work-card {
  min-width: 0;
  padding: 1rem;
  border: 1px solid #dce7e0;
  border-radius: 0.85rem;
  background: #fff;
  box-shadow: 0 8px 24px rgba(18, 50, 33, 0.04);
}

.ipm-member-work-card {
  box-shadow: none;
}

.ipm-member-section-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin: -1rem -1rem 0;
  padding: 0.9rem 1rem;
  border-bottom: 1px solid #e7eee9;
  border-radius: 0.85rem 0.85rem 0 0;
  background: #fbfdfb;
}

.ipm-member-section-heading--flush {
  margin-bottom: 1rem;
}

.ipm-member-section-heading h3 {
  margin-top: 0.15rem;
  color: #10241a;
  font-size: 0.92rem;
  font-weight: 800;
}

.ipm-member-eyebrow {
  color: #197443;
  font-size: 0.62rem;
  font-weight: 800;
  letter-spacing: 0.12em;
}

.ipm-member-section-chip {
  max-width: 24rem;
  overflow: hidden;
  padding: 0.3rem 0.6rem;
  border: 1px solid #c9dfd0;
  border-radius: 999px;
  color: #0d5b34;
  background: #eff8f2;
  font-size: 0.65rem;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ipm-member-info-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.75rem;
  margin-top: 1rem;
}

.ipm-member-info-grid > div {
  min-width: 0;
  padding: 0.75rem;
  border-radius: 0.65rem;
  background: #f7faf8;
}

.ipm-member-info-grid dt {
  color: #84938b;
  font-size: 0.67rem;
}

.ipm-member-info-grid dd {
  margin-top: 0.25rem;
  overflow-wrap: anywhere;
  color: #263a2f;
  font-size: 0.75rem;
  font-weight: 650;
}

.ipm-member-answer-block {
  padding: 1rem;
  border: 1px solid #dce7e0;
  border-radius: 0.85rem;
  background: #fff;
}

@keyframes ipm-member-modal-enter {
  from {
    opacity: 0;
    transform: translate(-50%, calc(-50% + 0.75rem)) scale(0.985);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
}
@media (max-width: 960px) {
  .ipm-member-modal {
    width: calc(100vw - 1rem);
    height: calc(100vh - 1rem);
    height: calc(100dvh - 1rem);
    border-radius: 0.85rem;
  }
  .ipm-member-info-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 640px) {
  .ipm-member-modal-header {
    gap: 0.65rem;
    padding: 0.85rem;
  }
  .ipm-member-modal-body {
    padding: 0.65rem;
  }
  .ipm-member-modal-tabs {
    padding: 0 0.65rem;
  }
  .ipm-member-card,
  .ipm-member-work-card {
    padding: 0.75rem;
  }
  .ipm-member-section-heading {
    align-items: flex-start;
    margin: -0.75rem -0.75rem 0;
    padding: 0.75rem;
  }
  .ipm-member-section-chip {
    max-width: 45%;
  }
  .ipm-member-info-grid {
    grid-template-columns: 1fr;
  }
}
@media (prefers-reduced-motion: reduce) {
  .ipm-member-modal {
    animation-duration: 0.01ms;
    animation-iteration-count: 1;
  }
}`],
})
export class PageIpManagementConsultationsComponent implements OnInit {
    public consultations: any[] = [];
    public selected: any = null;
    public detailOpen: boolean = false;
    public detailTab: MemberDetailTab = 'overview';
    public storedAnswer: StoredAnswerView = { title: '', body: '', files: [] };
    public search: any = { text: '', status: '' };
    public page: number = 1;
    public readonly pageSize: number = 10;
    public statuses: string[] = ['open', 'in_progress', 'answered', 'closed'];
    public replyText: string = '';
    public loading: boolean = true;
    public saving: boolean = false;
    public errorStatus: number = 0;
    public errorCode: string = '';
    public errorMessage: string = '';
    public documentSubject: string = '';
    public documentMessage: string = '';
    public documentFiles: File[] = [];
    public dispatchHistory: any[] = [];
    public dispatchSending: boolean = false;
    public dispatchLoading: boolean = false;
    public uploadProgress: number = 0;
    private detailSequence: number = 0;
    private readonly maxDocumentFiles: number = 5;
    private readonly maxDocumentFileSize: number = 20 * 1024 * 1024;
    private readonly maxDocumentTotalSize: number = 40 * 1024 * 1024;
    private readonly allowedDocumentExtensions: string[] = [
        '.pdf', '.hwp', '.hwpx', '.doc', '.docx', '.xls', '.xlsx',
        '.ppt', '.pptx', '.txt', '.csv', '.zip', '.jpg', '.jpeg', '.png'
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/access');
        await this.load();
    }

    public async load(preserveSelection: boolean = false) {
        const selectedId = preserveSelection && this.detailOpen
            ? this.selected?.id
            : '';
        this.loading = true;
        this.errorStatus = 0;
        await this.service.render();
        try {
            const consultationResponse = await wiz.call('list_consultations', {});
            this.consultations = this.responseData(
                consultationResponse,
                '회원 상담 목록을 불러오지 못했습니다.'
            ) || [];
            const next = selectedId
                ? this.consultations.find((item) => item.id === selectedId) || null
                : null;
            const changed = this.selected?.id !== next?.id;
            this.selected = next;
            this.storedAnswer = this.parseStoredAnswer(next?.answer);
            if (this.selected) {
                if (changed) {
                    this.replyText = '';
                    this.resetDocumentDraft(this.selected);
                }
                await this.loadDispatchHistory(this.selected.id, false);
            } else {
                this.detailOpen = false;
                this.dispatchHistory = [];
            }
        } catch (error) {
            this.captureError(error, 'IP 관리 운영 큐를 불러오지 못했습니다.');
            this.consultations = [];
            this.selected = null;
            this.detailOpen = false;
            this.storedAnswer = { title: '', body: '', files: [] };
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    private responseData(response: any, fallback: string) {
        const status = Number(response?.code || 0);
        if (status >= 200 && status < 300) return response?.data;

        const payload = response?.data?.error || {};
        const error: any = new Error(payload.message || fallback);
        error.status = status;
        error.code = payload.code || 'REQUEST_FAILED';
        error.details = payload.details || [];
        throw error;
    }

    private captureError(error: any, fallback: string) {
        let payload = error?.responseJSON || error;
        if (!error?.responseJSON && typeof error?.responseText === 'string') {
            try {
                payload = JSON.parse(error.responseText);
            } catch (_parseError) { }
        }
        const detail = payload?.data?.error || payload?.error || error?.data?.error || {};
        const responseStatus = typeof payload?.code === 'number' ? payload.code : error?.status;
        this.errorStatus = Number(responseStatus || detail?.status || 0);
        this.errorCode = String(detail?.code || payload?.errorCode || error?.code || 'REQUEST_FAILED');
        this.errorMessage = String(detail?.message || payload?.message || error?.message || fallback);
    }

    public get filteredConsultations() {
        const text = this.search.text.trim().toLowerCase();
        return this.consultations.filter((item) => {
            const searchable = [item.tenant?.name, item.requester?.display_name, item.subject, item.body, item.category].join(' ').toLowerCase();
            return (!text || searchable.includes(text)) && (!this.search.status || item.status === this.search.status);
        });
    }

    public get pageCount() {
        return Math.max(1, Math.ceil(this.filteredConsultations.length / this.pageSize));
    }

    public get pageNumbers() {
        return Array.from({ length: this.pageCount }, (_, index) => index + 1);
    }

    public get paginatedConsultations() {
        const start = (this.page - 1) * this.pageSize;
        return this.filteredConsultations.slice(start, start + this.pageSize);
    }

    public async resetPage() {
        this.page = 1;
        await this.service.render();
    }

    public async goToPage(page: number) {
        this.page = Math.min(Math.max(page, 1), this.pageCount);
        await this.service.render();
    }

    public async selectItem(item: any) {
        if (!item) return;
        const sequence = ++this.detailSequence;
        this.selected = item;
        this.detailOpen = true;
        this.detailTab = 'overview';
        this.storedAnswer = this.parseStoredAnswer(item.answer);
        this.replyText = '';
        this.resetDocumentDraft(item);
        await this.service.render();
        await this.loadDispatchHistory(item.id, true, sequence);
    }

    public async closeDetail() {
        if (this.saving || this.dispatchSending) return;
        this.detailSequence += 1;
        this.detailOpen = false;
        this.detailTab = 'overview';
        this.selected = null;
        this.storedAnswer = { title: '', body: '', files: [] };
        this.replyText = '';
        this.documentFiles = [];
        this.dispatchHistory = [];
        this.dispatchLoading = false;
        await this.service.render();
    }

    public async selectDetailTab(tab: MemberDetailTab) {
        if (!this.detailOpen || this.detailTab === tab) return;
        this.detailTab = tab;
        await this.service.render();
    }

    private resetDocumentDraft(item: any) {
        this.documentSubject = '[웅빈] ' + (item?.subject || '상담') + ' 관련 서류';
        const name = item?.requester?.display_name || '고객';
        this.documentMessage = name + '님 안녕하세요? 주식회사 웅빈입니다.\n\n'
            + '문의하신 상담 관련 서류를 첨부드립니다.\n'
            + '첨부파일을 확인해주시기 바랍니다. 감사합니다.';
        this.documentFiles = [];
        this.dispatchHistory = [];
    }

    public async loadDispatchHistory(
        id: string,
        render: boolean = true,
        sequence: number = this.detailSequence
    ) {
        if (!id) return;
        this.dispatchLoading = true;
        if (render) await this.service.render();
        try {
            const response = await wiz.call('list_consultation_dispatches', { id });
            const history = this.responseData(
                response,
                '서류 발송 이력을 불러오지 못했습니다.'
            ) || [];
            if (sequence !== this.detailSequence || this.selected?.id !== id) return;
            this.dispatchHistory = history;
        } catch (error) {
            if (sequence !== this.detailSequence || this.selected?.id !== id) return;
            this.dispatchHistory = [];
            this.captureError(error, '서류 발송 이력을 불러오지 못했습니다.');
        } finally {
            if (sequence === this.detailSequence && this.selected?.id === id) {
                this.dispatchLoading = false;
                if (render) await this.service.render();
            }
        }
    }

    public async selectDocumentFiles(event: any) {
        const files = Array.from(event?.target?.files || []) as File[];
        if (event?.target) event.target.value = '';
        const accepted: File[] = [];
        const rejected: string[] = [];
        let total = this.documentFiles.reduce((sum, file) => sum + file.size, 0);
        for (const file of files) {
            const dot = file.name.lastIndexOf('.');
            const extension = dot >= 0 ? file.name.slice(dot).toLowerCase() : '';
            if (!this.allowedDocumentExtensions.includes(extension)) {
                rejected.push(file.name + ': 지원하지 않는 형식');
                continue;
            }
            if (!file.size || file.size > this.maxDocumentFileSize) {
                rejected.push(file.name + ': 파일당 20MB 초과');
                continue;
            }
            if (this.documentFiles.length + accepted.length >= this.maxDocumentFiles) {
                rejected.push(file.name + ': 최대 5개 초과');
                continue;
            }
            if (total + file.size > this.maxDocumentTotalSize) {
                rejected.push(file.name + ': 전체 40MB 초과');
                continue;
            }
            accepted.push(file);
            total += file.size;
        }
        this.documentFiles = [...this.documentFiles, ...accepted];
        if (rejected.length) await this.service.modal.error(rejected.join('\n'));
        await this.service.render();
    }

    public async removeDocumentFile(index: number) {
        this.documentFiles.splice(index, 1);
        await this.service.render();
    }

    public async sendDocuments() {
        if (!this.selected || this.dispatchSending) return;
        this.errorStatus = 0;
        this.errorCode = '';
        this.errorMessage = '';
        if (!this.documentSubject.trim() || !this.documentMessage.trim()) {
            await this.service.modal.error('답변 제목과 안내 문구를 입력해주세요.');
            return;
        }
        if (!this.documentFiles.length) {
            await this.service.modal.error('발송할 서류를 1개 이상 첨부해주세요.');
            return;
        }
        const confirmed = await this.service.modal.show({
            title: '회원 상담 서류 전달',
            message: '이 상담의 답변에 첨부서류 다운로드 링크를 등록합니다.',
            action: '전달',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'success'
        });
        if (!confirmed) return;

        this.dispatchSending = true;
        this.uploadProgress = 0;
        await this.service.render();
        try {
            const form = new FormData();
            form.append('id', this.selected.id);
            form.append('subject', this.documentSubject.trim());
            form.append('message', this.documentMessage.trim());
            form.append('file_count', String(this.documentFiles.length));
            this.documentFiles.forEach((file, index) => form.append('file_' + index, file));
            const upload: any = await this.service.file.upload(
                wiz.url('publish_member_consultation_documents'),
                form,
                async (percent: number) => {
                    this.uploadProgress = percent;
                    await this.service.render();
                }
            );
            const response = upload?.responseJSON || upload;
            const sent = this.responseData(response, '상담 서류를 발송하지 못했습니다.');
            this.documentFiles = [];
            if (sent) this.dispatchHistory = [sent, ...this.dispatchHistory];
            await this.load(true);
            await this.service.modal.success('상담 답변에 첨부서류를 등록했습니다.');
        } catch (error) {
            this.captureError(error, '상담 서류를 발송하지 못했습니다.');
            await this.service.modal.error(this.errorMessage);
        } finally {
            this.dispatchSending = false;
            await this.service.render();
        }
    }

    public downloadDocument(dispatch: any, file: any) {
        const query = new URLSearchParams({
            id: this.selected?.id || '',
            dispatch_id: dispatch.id,
            file_id: file.id
        });
        window.open(
            wiz.url('download_consultation_document') + '?' + query.toString(),
            '_blank',
            'noopener,noreferrer'
        );
    }

    public formatFileSize(size: number) {
        const bytes = Number(size || 0);
        if (bytes < 1024) return bytes + ' B';
        if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
        return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
    }

    public formatDate(value: string) {
        if (!value) return '-';
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return value;
        return new Intl.DateTimeFormat('ko-KR', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        }).format(date);
    }

    public documentFileType(name: string) {
        const value = String(name || '').trim();
        const dot = value.lastIndexOf('.');
        if (dot < 0 || dot === value.length - 1) return 'FILE';
        return value.slice(dot + 1).toUpperCase().slice(0, 5);
    }

    public answerAttachmentCount(value: unknown) {
        return this.parseStoredAnswer(value).files.length;
    }

    public consultationCaseNumber(item: any) {
        return item?.case_number
            || item?.caseNumber
            || item?.case?.case_number
            || item?.case?.caseNumber
            || '-';
    }

    private parseStoredAnswer(value: unknown): StoredAnswerView {
        const original = String(value || '').replace(/\r\n?/g, '\n').trim();
        const fallback = { title: '', body: original, files: [] as StoredAnswerFile[] };
        if (!original) return fallback;

        const lines = original.split('\n');
        const attachmentMarker = lines.findIndex((line) => line.trim() === '첨부서류');
        if (attachmentMarker < 0) return fallback;

        const contentLines = lines.slice(0, attachmentMarker);
        const titleIndex = contentLines.findIndex((line) => Boolean(line.trim()));
        const title = titleIndex >= 0 ? contentLines[titleIndex].trim() : '';
        const body = titleIndex >= 0
            ? contentLines.slice(titleIndex + 1).join('\n').trim()
            : contentLines.join('\n').trim();
        const files: StoredAnswerFile[] = [];

        for (let index = attachmentMarker + 1; index < lines.length; index += 1) {
            const line = lines[index].trim();
            if (!line.startsWith('- ')) continue;
            const name = line.slice(2).trim();
            let urlIndex = index + 1;
            while (urlIndex < lines.length && !lines[urlIndex].trim()) urlIndex += 1;
            const url = this.safeDocumentUrl(lines[urlIndex]?.trim() || '');
            if (!name || !url) continue;
            files.push({ name, url });
            index = urlIndex;
        }

        if (!files.length) return fallback;
        return { title, body, files };
    }

    private safeDocumentUrl(value: string) {
        try {
            const parsed = new URL(value, window.location.origin);
            const trustedOrigin = parsed.origin === window.location.origin
                || parsed.origin === 'https://admin.woongbin.seasonai.net';
            if (
                !trustedOrigin
                || !parsed.pathname.startsWith('/ip-management/consultation-documents/')
            ) return '';
            return parsed.toString();
        } catch (_error) {
            return '';
        }
    }

    public dispatchStatusClass(status: string) {
        if (status === '발송완료' || status === '전달완료') return 'border-emerald-200 bg-emerald-50 text-emerald-700';
        if (status === '발송실패') return 'border-rose-200 bg-rose-50 text-rose-700';
        return 'border-amber-200 bg-amber-50 text-amber-700';
    }

    public async sendReply() {
        if (!this.selected || this.saving) return;
        const reply = this.replyText.trim();
        if (!reply) {
            await this.service.modal.error('답변 내용을 입력해주세요.');
            return;
        }

        const confirmed = await this.service.modal.show({
            title: '상담 답변 저장',
            message: '회원에게 표시할 상담 답변을 저장합니다.',
            action: '저장',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'success'
        });
        if (!confirmed) return;

        this.saving = true;
        this.errorStatus = 0;
        await this.service.render();
        try {
            const response = await wiz.call('reply_consultation', {
                id: this.selected.id,
                answer: reply,
                status: 'answered'
            });
            this.responseData(response, '상담 답변을 저장하지 못했습니다.');
            await this.load(true);
            this.replyText = '';
            await this.service.modal.success('상담 답변을 저장했습니다.');
        } catch (error) {
            this.captureError(error, '상담 답변을 저장하지 못했습니다.');
            await this.service.modal.error(this.errorMessage);
        } finally {
            this.saving = false;
            await this.service.render();
        }
    }

    public statusClass(status: string) {
        if (status === 'open') return 'border-amber-200 bg-amber-50 text-amber-700';
        if (status === 'in_progress') return 'border-sky-200 bg-sky-50 text-sky-700';
        if (status === 'answered') return 'border-emerald-200 bg-emerald-50 text-emerald-700';
        if (status === 'closed') return 'border-slate-200 bg-slate-100 text-slate-600';
        return 'border-slate-200 bg-slate-100 text-slate-600';
    }

    public statusLabel(status: string) {
        if (status === 'open') return '접수';
        if (status === 'in_progress') return '처리 중';
        if (status === 'answered') return '답변 완료';
        if (status === 'closed') return '종료';
        return status || '-';
    }
}

export default PageIpManagementConsultationsComponent;